'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleOutgoingEvent = exports.handleIncomingEvent = exports.handleInvokeEvents = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.handleAppEvents = handleAppEvents;

var _emit = require('./emit');

var _WidgetFactories = require('../Widget/WidgetFactories');

var _WidgetFactories2 = _interopRequireDefault(_WidgetFactories);

var _WidgetRequest = require('../Widget/WidgetRequest');

var _WidgetRequest2 = _interopRequireDefault(_WidgetRequest);

var _WidgetResponse = require('../Widget/WidgetResponse');

var _WidgetResponse2 = _interopRequireDefault(_WidgetResponse);

var _Event = require('./Event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @TODO this should form the basic for the driver for WidgetWindowBridge
 * @internal
 */
var EventHandler = function () {
  function EventHandler() {
    (0, _classCallCheck3.default)(this, EventHandler);
  }

  (0, _createClass3.default)(EventHandler, null, [{
    key: 'handleOutgoingEvent',

    /**
     * @param {WidgetWindowBridge} windowBridge
     * @param {function} resolve
     * @param {function} reject
     * @param {string} event
     * @param {*} data
     * @param {string} invocationType
     */
    value: function handleOutgoingEvent(windowBridge, resolve, reject, _ref) {
      var event = _ref.event,
          invocationType = _ref.invocationType,
          data = _ref.data;

      if (invocationType === _Event.INVOCATION_REQUESTRESPONSE) {
        windowBridge.emitRequest(event, data).then(function (_ref2) {
          var request = _ref2.request,
              emit = _ref2.emit;

          // resolve the promise when response comes
          var responseExecutor = function responseExecutor(response) {
            return response.status == 'success' ? resolve(response.body) : reject(response.body);
          };
          _emit.MessageBus.once(request.correlationId, responseExecutor);
          return { request: request, emit: emit };
        }).then(function (_ref3) {
          var emit = _ref3.emit;
          return emit();
        }) // finally after registering a response listener send the request
        ;
      } else if (invocationType === _Event.INVOCATION_FIREANDFORGET) {
        windowBridge.emitRequest(event, data).then(function (_ref4) {
          var emit = _ref4.emit;
          return emit();
        }).then(function () {
          return resolve(data);
        });
      }
    }

    /**
     * @param {WidgetWindowBridge} windowBridge
     * @param {string} event
     * @param {string} invocationType
     * @param {WidgetRequest} request
     */

  }, {
    key: 'handleIncomingEvent',
    value: function handleIncomingEvent(windowBridge, _ref5, request) {
      var event = _ref5.event,
          invocationType = _ref5.invocationType;

      if (invocationType === _Event.INVOCATION_REQUESTRESPONSE) {
        var cb = function cb(error, data) {
          windowBridge.emitResponse(event, error, data, request).then(function (_ref6) {
            var response = _ref6.response,
                emit = _ref6.emit;
            return emit();
          });
        };

        _emit.IncomingEventDispatcher.emit(event, cb, request.body);
      } else if (invocationType === _Event.INVOCATION_FIREANDFORGET) {
        _emit.IncomingEventDispatcher.emit(event, request.body);
      } else {
        throw new Error('can not handle incoming event: unknown invocation type');
      }
    }
  }]);
  return EventHandler;
}();

/**
 * @param {WidgetWindowBridge} windowBridge
 * @param {String} eventName
 * @param {Object} eventProps
 * @param {{ data:* }} event
 */
/**
 * Handles the delivery of outgoing events (those originating in the application) and the receipt of incoming events
 * (those originating in a 3rd party, like the help desk application)
 *
 * @module Core/EventHandler
 */

var dispatchIncomingEvent = function dispatchIncomingEvent(windowBridge, eventName, eventProps, event) {
  var rawMessage = event.data;


  var message = _WidgetFactories2.default.parseMessageFromJS(rawMessage);
  if (message instanceof _WidgetRequest2.default && eventProps.invocationType === _Event.INVOCATION_REQUESTRESPONSE) {
    _emit.MessageBus.emit(eventName, message);
    return;
  }

  if (message instanceof _WidgetRequest2.default && eventProps.invocationType === _Event.INVOCATION_FIREANDFORGET) {
    _emit.MessageBus.emit(eventName, message);
    return;
  }

  if (message instanceof _WidgetResponse2.default && eventProps.invocationType === _Event.INVOCATION_REQUESTRESPONSE) {
    _emit.MessageBus.emit(message.correlationId, message);
    return;
  }
};

/**
 * Registers an outgoing event listener
 *
 * @function
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 */
var handleInvokeEvents = exports.handleInvokeEvents = function handleInvokeEvents(windowBridge, app) {
  _emit.OutgoingEventDispatcher.onInvoke(EventHandler.handleOutgoingEvent.bind(null, windowBridge));
};

/**
 * Handles an incoming or outgoing event
 *
 * @function
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 * @param {String} eventName
 * @param {{invocationType:String}} eventProps
 * @return null
 */
function handleAppEvents(windowBridge, app, eventName, eventProps) {
  var channelType = eventProps.channelType;

  if (channelType === _Event.CHANNEL_INCOMING) {
    handleIncomingEvent(windowBridge, app, eventName, eventProps);
  } else if (channelType === _Event.CHANNEL_OUTGOING) {
    handleOutgoingEvent(windowBridge, app, eventName, eventProps);
  } else {
    throw new Error('unknown event channel');
  }
}

/**
 * Handles an incoming event
 *
 * @function
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 * @param {String} eventName
 * @param {Object} eventProps
 * @return null
 */
var handleIncomingEvent = function handleIncomingEvent(windowBridge, app, eventName, eventProps) {
  var invocationType = eventProps.invocationType,
      otherProps = (0, _objectWithoutProperties3.default)(eventProps, ['invocationType']);


  if (-1 !== [_Event.INVOCATION_FIREANDFORGET, _Event.INVOCATION_REQUESTRESPONSE].indexOf(invocationType)) {

    var invocation = (0, _extends3.default)({ event: eventName, invocationType: invocationType }, otherProps);
    _emit.MessageBus.on(eventName, EventHandler.handleIncomingEvent.bind(undefined, windowBridge, invocation));
    windowBridge.on(eventName, dispatchIncomingEvent.bind(undefined, windowBridge, eventName, eventProps));
  } else {
    throw new Error('unknown invocation type');
  }
};

/**
 * Handles an outgoing event
 *
 * @function
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 * @param {string} eventName
 * @param {{invocationType:String, ...other}} eventProps
 */
exports.handleIncomingEvent = handleIncomingEvent;
var handleOutgoingEvent = function handleOutgoingEvent(windowBridge, app, eventName, eventProps) {
  var invocationType = eventProps.invocationType,
      otherProps = (0, _objectWithoutProperties3.default)(eventProps, ['invocationType']);


  if (-1 !== [_Event.INVOCATION_FIREANDFORGET, _Event.INVOCATION_REQUESTRESPONSE].indexOf(invocationType)) {
    var handler = function handler(resolve, reject, data) {
      return EventHandler.handleOutgoingEvent(windowBridge, resolve, reject, (0, _extends3.default)({ event: eventName, data: data, invocationType: invocationType }, otherProps));
    };

    _emit.OutgoingEventDispatcher.on(eventName, handler);
    windowBridge.on(eventName, dispatchIncomingEvent.bind(undefined, windowBridge, eventName, eventProps));
  } else {
    throw new Error('unknown invocation type');
  }
};
exports.handleOutgoingEvent = handleOutgoingEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/EventHandler.js
// module id = 32
// module chunks = 0